<template>
  <div
    class="main scroll"
    @click="cancelContent"
    @contextmenu.prevent="contentRight($event)"
    ref="scroll"
  >
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <!-- <div @click="$router.back()" class="name">学生素材</div>
          <div class="icon">></div> -->
          <div class="main blue">
           个人素材
          </div>
          <!-- <a-icon style="{color:#f1f8fd}" type="caret-down" /> -->
        </div>
        <div class="right">
          <div class="num">
            素材数量<span class="blue">{{ photoList.length }}</span>
          </div>
          <div class="msg">
            <div class="txt blue">素材信息</div>
            <a-icon style="{color:#898989}" type="caret-down" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="frame-list">
          <img
            @click="uploadModal = true"
            class="addframe"
            :src="require('@/assets/upload-05.png')"
            alt=""
          />
          <div
            @click="selectPhoto($event, index)"
            @dblclick="showBigPic(item.img_personal)"
            v-for="(item, index) in photoList"
            :key="index"
            @contextmenu.prevent="photoRight($event, index)"
            class="cell"
            :class="item.select ? 'select' : ''"
            :style="{backgroundImage:'url('+item.img_personal+')'}"
          >
            <!-- <img class="photo" :src="item.img_personal" alt="" /> -->
            <!-- <div v-if="item.is_sb && !item.binding" class="tip">已识</div>
            <div v-if="item.binding" class="bind">分配</div> -->
          </div>
        </div>
        <div class="pagebox" style="text-align:center">
          <a-pagination
            show-quick-jumper
            :defaultPageSize="24"
            :current="page"
            :total="total"
            @change="onChangePage"
          />
        </div>
      </div>
      <div
        v-show="showRight"
        class="rightContent"
        :style="rightStyle"
      >
        <div @click="uploadModal = true" class="cell">上传素材</div>
        <div @click="handleSelectAll" class="cell">选择全部</div>
        <div @click="delModal = true" class="cell">删除素材</div>
      </div>
      <a-modal :visible="editModal" centered :closable="false" footer="">
        <div class="modal3">
          <img :src="require('../assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">修改素材名称</div>
            <a-input
              v-if="currentPhoto"
              v-model="currentPhoto.name"
              :placeholder="currentPhoto ? currentPhoto.name : ''"
            />
            <div class="btns">
              <a-button @click="editModal = false">取消</a-button>
              <a-button @click="handleEditPhoto" type="primary">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="delModal" centered :closable="false" footer="">
        <div class="modal3 red">
          <img :src="require('../assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">删除此素材所有照片，不可恢复。是否继续？</div>
            <div class="btns">
              <a-button @click="delModal = false">取消</a-button>
              <a-button @click="handleDelPhoto" type="danger">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="previewVisible" :footer="null" width="660px" @cancel="handleCancel">
        <div style="padding:20px">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </div>
      </a-modal>
      <a-modal
        :visible="uploadModal"
        centered
        :title="'上传素材'"
        width="1180px"
        footer=""
        @cancel="uploadModal = false"
      >
        <div class="photos">
          <a-upload-dragger
            name="img_personal"
            list-type="picture-card"
            :multiple="true"
            :file-list="fileList"
            :before-upload="beforeUpload"
            :action="$api.domain + $api.uploadPersonal"
            :headers="{Authorization: $store.state.headers}"
            @preview="handlePreview"
            @change="handleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              点击或者拖拽图片到此处
            </p>
          </a-upload-dragger>
        </div>
      </a-modal>
      <a-modal
        :visible="disModal"
        centered
        :title="'分配照片'"
        width="1200px"
        ok-text="确认"
        cancel-text="取消"
        @ok="handleDis"
        @cancel="cancelDisModel"
      >
        <div class="photos">
          <div class="dis-list">
            <div v-for="(item, index) in disList" :key="index" class="dis-cell">
              <img class="dis-photo" :src="item.img_url" alt="" />
              <div v-if="item.is_sb && !item.binding" class="tip">已识</div>
              <div v-if="item.binding" class="bind">分配</div>
            </div>
          </div>
          <div class="section">
            <div class="head">
              <div class="name">学生列表：</div>
              <div @click="handleAllDis" class="alldis">全部分配</div>
            </div>
            <div class="student-list">
              <div
                @click="selectStudent(index)"
                v-for="(item, index) in studentList"
                :key="index"
                class="student-cell"
                :class="item.select ? 'select' : ''"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { checkFileFormat } from "@/utils/validate";
// import BetterScroll from "better-scroll";
import _ from "lodash";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  data() {
    return {
      photoList: [],
      currentPhoto: null,
      currentIndex: -1,
      rightContentLeft: 0,
      rightContentTop: 0,
      showRight: false,
      photoName: "",
      editModal: false,
      delModal: false,
      backimg1: require("../assets/doc.png"),
      backimg2: require("../assets/doc-01.png"),
      studentList: [],
      id: "",
      studentId:'',
      studentName: "",
      uploadModal: false,
      previewVisible: false,
      previewImage: "",
      fileList: [],
      type: "全部照片",
      disList: [],
      disModal: false,
      rightStyle:{
        left:0,
        top:0
      },
      limit:24,
      page:1,
      total:0
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.scroll = new BetterScroll(this.$refs.scroll, {
    //     scrollY: true,
    //     scrollbar: true,
    //     mouseWheel: {
    //       speed: 20,
    //       invert: false,
    //       easeTime: 300,
    //     },
    //   });
    // });
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    // this.id = this.$route.params.id;
    // this.studentName = this.$route.query.name;
    // this.studentId = this.$route.params.studentId
    if (this.userInfo) {
      this.getPhoto();
    }
  },
  filters: {
    filterIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getPhoto();
      }
    },
  },
  methods: {
    // 上传前校验文件格式
    beforeUpload(file) {
      if (!checkFileFormat(file)) {
        this.$message.error("请上传图片格式的文件");
        return false;
      }
      return true;
    },
    showBigPic(url) {
      this.previewImage = this.clearUrl(url) 
      this.previewVisible = true
    },
    cancelDisModel() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.disModal = false;
    },
    handleAllDis() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = true;
        return arr;
      });
    },
    selectStudent(index) {
      this.studentList[index].select = !this.studentList[index].select;
      this.$forceUpdate();
    },
    showDisModel() {
      var disList = [];
      var sbList = [];
      this.photoList.forEach((arr) => {
        if (arr.select && !arr.is_sb && !arr.binding) {
          disList.push(arr);
        }
        if (arr.select && arr.is_sb && !arr.binding) {
          sbList.push(arr);
        }
      });
      if (disList.length > 0) {
        this.disModal = true;
        this.disList = disList;
      } else if (sbList.length > 0) {
        this.disModal = true;
        this.disList = sbList;
      } else {
        this.$message.error("未选择可分配的图片");
      }
      this.disList = this.disList.map((arr) => {
        arr.select = false;
        return { ...arr };
      });
      if (this.disList.length == 1) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.img_info,
          headers: { Authorization: this.$store.state.headers },
          data: { album_id: this.disList[0].id },
        })
          .then((res) => {
            if (res.data.status == 200) {
              if (res.data.data.sb) {
                this.disList[0].sb = res.data.data.sb;
                this.studentList.forEach((arr, index) => {
                  if (arr.id == res.data.data.sb) {
                    this.studentList[index].select = true;
                  }
                });
              }
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    handleDis() {
      var img_ids = [];
      var student_ids = [];
      this.studentList.map((arr) => {
        if (arr.select) {
          student_ids.push(arr.id);
        }
      });
      this.disList.map((arr) => {
        img_ids.push(arr.id);
      });
      const hide = this.$message.loading({ content: "上传中", key: "loading" });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.dis_all,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_img_id: img_ids.join(","),
          student_id: student_ids.join(","),
        },
      })
        .then((res) => {
          setTimeout(hide, 1000);
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.getPhoto();
            this.disModal = false;
          }
        })
        .catch(() => {
          setTimeout(hide, 1000);
          this.$message.error("网络或服务器未知错误");
        });
    },
    changeType() {
      this.getPhoto();
    },
    handleUpload() {
      if (this.uploadState) return false
      var img_url = [];
      var errors = []
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].status == 'done' && this.fileList[i].response && this.fileList[i].response.data) {
            img_url.push(this.fileList[i].response.data.url);
        } else if (this.fileList[i].status == 'uploading') {
          state = false;
          break;
        } else if (this.fileList[i].status == 'error' || this.fileList[i].response != 200) {
          errors.push(i+1)
        } 
      }
      if (!state) return false;
      if (errors.length > 0) {
        this.$message.error(`第${errors.join(',')}文件上传失败`)
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.addStudentPhoto,
        headers: { Authorization: this.$store.state.headers },
        data: { album_id: this.id, img_url: img_url.join(","),student_id:this.studentId },
      })
        .then((res) => {
          this.uploadState = false
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({ content: res.data.msg, key:'uploadState', duration: 2 });
          }, 1000);
          if (res.data.status == 200) {
            this.uploadModal = false;
            this.getPhoto();
          }
        })
        .catch(() => {
          this.uploadState = false
          this.$message.error("网络或服务器未知错误");
        });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewImage = this.clearUrl(this.previewImage)
      this.previewVisible = true;
    },
    clearUrl(url) {
      console.log(url)
      if(!url) {
        url = ''
      } else if (url.indexOf('?')) {
        url = url.split('?')[0]
      } 
      return url
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
      var img_url = [];
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response && this.fileList[i].response.data) {
          img_url.push(this.fileList[i].response.data.url);
        } else {
          state = false;
          break;
        }
      }
      if (!state) return false;
      this.uploadModal = false 
      this.$message.info('素材添加成功')
      this.fileList = []
      this.getPhoto()
    },
    handleCancel() {
      this.previewVisible = false;
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows;
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    selectPhoto($event, index) {
      if ($event.shiftKey) {
        this.photoList = this.photoList.map((arr, arrIndex) => {
          arr.select = false;
          if (this.currentIndex >= index) {
            if (arrIndex >= index && arrIndex <= this.currentIndex) {
              arr.select = true;
            }
          } else {
            if (arrIndex <= index && arrIndex >= this.currentIndex) {
              arr.select = true;
            }
          }
          return arr;
        });
        this.currentIndex = index;
        return false;
      }
      if ($event.ctrlKey) {
        this.photoList[index].select = !this.photoList[index].select;
        this.$forceUpdate();
        this.currentIndex = index;
        return false;
      }
      if (!$event.shiftKey && !$event.ctrlKey) {
        this.photoList = this.photoList.map((arr, index2) => {
          arr.select = false;
          if (index2 == index) {
            arr.select = true;
          }
          return arr;
        });
        this.currentIndex = index;
      }
    },
    editPhoto(index) {
      this.currentPhoto = _.cloneDeep(this.photoList[index]);
      this.editModal = true;
    },
    handleSelectAll() {
      this.photoList = this.photoList.map((arr) => {
        arr.select = true;
        return arr;
      });
    },
    handleEditPhoto() {
      if (!this.currentPhoto) {
        this.$message.error("未填写任何姓名");
      } else {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.editPhoto,
          headers: { Authorization: this.$store.state.headers },
          data: { id: this.currentPhoto.id, name: this.currentPhoto.name },
        })
          .then((res) => {
            this.studentName = "";
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.editModal = false;
              this.getPhoto();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    handleDelPhoto() {
      var ids = [];
      this.photoList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.p_id);
        }
      });
      if (ids.length > 0) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.delPersonalPhoto,
          headers: { Authorization: this.$store.state.headers },
          data: { p_ids: ids.join(",")},
        })
          .then((res) => {
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.delModal = false;
              this.getPhoto();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      } else {
        this.$message.error("未选择任何素材");
      }
    },
    contentRight(e) {
      console.log(e)
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.photoList = this.photoList.map((arr) => {
        arr.select = false;
        return arr;
      });
      console.log(e);
    },
    cancelContent() {
      this.showRight = false;
    },
    photoRight(e, index) {
      e.stopPropagation();
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.currentPhoto = _.cloneDeep(this.photoList[index]);
      if (!this.photoList[index].select) {
        this.photoList = this.photoList.map((arr) => {
          arr.select = false;
          return arr;
        });
        this.photoList[index].select = true;
      }
      this.currentIndex = index;
    },
    onChangePage(e) {
      console.log(e)
      this.page = e
      this.getPhoto()
    },
    getPhoto() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.personalPhoto,
        headers: { Authorization: this.$store.state.headers },
        params: {
          limit: this.limit,
          page: this.page
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.total = res.data.data.count
            this.photoList = res.data.data.list.map((arr) => {
              arr.select = false;
              arr.img_personal += '?x-image-process=image/resize,w_380/quality,Q_80'
              return arr;
            });
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.student-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  .cell {
    cursor: pointer;
    margin-bottom: 30px;
  }
  .tx {
    width: 60px;
    height: 60px;
    border-radius: 60px;
    margin-right: 30px;
  }
  .name {
    width: 60px;
    text-align: center;
    color: #888;
    margin-top: 10px;
    font-size: 14px;
  }
}
.scroll {
  position: absolute;
  left: -20px;
  right: -20px;
  padding-left: 20px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  box-sizing: border-box;
  .scroll-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addframe {
    width: 175px;
    margin-bottom: 30px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }

  .cell {
    width: 175px;
    height: 143px;
    display: flex;
    flex-direction: row;
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-right: 30px;
    position: relative;
    background-size: contain;
    background-position: center;
    background-color: #eee;
    background-repeat: no-repeat;
    .photo {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #67b0dc;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    .bind {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #df815c;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    &.select {
      border: 3px solid #67b0dc;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.3);
      }
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
        }
      }
    }
  }
}
.frame-list div,
.frame-list span {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -ms-user-select: none;
}
::-webkit-scrollbar-track-piece {
  background-color: #f1f1f1;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #a8b3bb;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
.head-title .left .name {
  font-size: 12px;
}
.head-title .left .icon {
  margin: 0 6px;
}
::v-deep .ant-select-selection-selected-value {
  font-size: 12px;
}
::v-deep .ant-upload.ant-upload-drag {
  margin-bottom: 8px;
}
::v-deep .ant-upload-list {
  overflow: hidden;
}
.dis-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  .dis-cell {
    width: 175px;
    height: 143px;
    margin-bottom: 10px;
    box-sizing: border-box;
    margin-right: 10px;
    position: relative;
    .dis-photo {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #67b0dc;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    .bind {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #df815c;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    &.select {
      border: 3px solid #67b0dc;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.3);
      }
    }
  }
}
.section {
  width: 100%;
  margin-top: 5px;
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .name {
      color: #67b0dc;
      margin-right: 6px;
    }
    .alldis {
      background: #67b0dc;
      color: #fff;
      font-size: 12px;
      border-radius: 100px;
      padding: 4px 10px;
      cursor: pointer;
    }
  }
  .student-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .student-cell {
      padding: 4px 10px;
      width: 80px;
      border-radius: 20px;
      background: #f1f1f1;
      border: 1px solid #eee;
      color: #898989;
      margin-right: 10px;
      text-align: center;
      cursor: pointer;
      &.select {
        background: #67b0dc;
        color: #fff;
      }
    }
  }
}
</style>
